import axios from 'axios';
import authHeader from './auth-header';
import API_URL from '../constants/api-urls.constant';


class McService {

  add(info) {
    return axios.post(`${API_URL.mc.add}`, info, { headers: authHeader() });
  }

  update(info) {
    return axios.post(`${API_URL.mc.update}`, info, { headers: authHeader() });
  }

  getMcs(info) {
    return axios.post(`${API_URL.mc.getMcs}`, info, { headers: authHeader() });
  }

  getMcToPrint(info) {
    return axios.post(`${API_URL.mc.getMcToPrint}`, info, { headers: authHeader() });
  }

  getMcDetails(info) {
    return axios.post(`${API_URL.mc.getMcDetails}`, info, { headers: authHeader() });
  }

}

export default new McService();
